import { Component, OnDestroy, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { UserService } from '../../services/user.service';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, NgbCollapseModule],
  templateUrl: './header.component.html',
  styleUrls: ['./styles.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
  isMenuCollapsed = true;
  appUrl = '';
  loggedIn = false;
  isBrowser = false;
  wishlistView = false;
  menuOpen = false;
  title = 'Verlanglijst';
  timeout;
  currentDate = Date.now();
  private subscriptionAuth: Subscription;
  private subscriptionVisitWishList: Subscription;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private userService: UserService,
    private gtmService: GoogleTagManagerService
  ) {}

  ngOnInit() {
    //setTimeout(() => {
      if (isPlatformBrowser(this.platformId)) {
        this.isBrowser = true;
        if (this.userService.isLoggedIn()) {
          this.loggedIn = true;
        }
      }
   // });

    this.subscriptionAuth = this.userService.authNavStatus$.subscribe(loggedInUser => {
 //     setTimeout(() => {
        if (loggedInUser) {
          this.loggedIn = true;
        } else {
          this.loggedIn = false;
        }
   //   });
    });

    this.subscriptionVisitWishList = this.userService.visitWishListStatus$.subscribe(active => {
 //     setTimeout(() => {
        if (active) {
          this.wishlistView = true;
        } else {
          this.wishlistView = false;
        }
 //     });
    });

    if (isPlatformBrowser(this.platformId)) {
      const gtmTag = {
        event: 'firstPageLoad',
        loggedIn: this.userService.isLoggedIn()
      };
      
      this.gtmService.pushTag(gtmTag);
    }

  }

  logout() {
    //   this.memberService.setIsRequesting(true);
    this.userService.logout('none');
    this.loggedIn = false;
  }

  navigateWishListsView() {
    // this.memberService.navigateWishListsView();
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = this.appUrl + '/mijnlijstjes?view=all';
    }
  }

  navigateAddWishListView() {
    // this.memberService.navigateAddWishListView();
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = this.appUrl + '/mijnlijstjes?view=add';
    }
  }

  toggleMenu(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.isMenuCollapsed = !this.isMenuCollapsed;
  }

  ngOnDestroy(): void {
    this.subscriptionAuth.unsubscribe();
    this.subscriptionVisitWishList.unsubscribe();
  }
}